mutation UpdateEventSettings(
  $termsUrl: String
  $termsVersion: String
  $applyToUpcomingEvents: Boolean
) {
  updateEventSettings(
    input: {
      termsUrl: $termsUrl
      termsVersion: $termsVersion
      applyToUpcomingEvents: $applyToUpcomingEvents
    }
  ) {
    eventSettings {
      termsUrl
      termsVersion
      upcomingEventsUsingDefaultCount
    }
    updatedEventsCount
  }
}
